module.exports = __webpack_public_path__ + "static/media/lowresportfolio-39.05610d36.jpg";